// extracted by mini-css-extract-plugin
export var documentation = "_kx-1";
export var menu = "_kx-0";